import React, {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'

import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import { NumericFormat } from 'react-number-format';
import {
    changeAttribute,
    getAttribute,
    getImageWithPrefix,
    getLocalDate,
    hasAttribute,
    setAttribute,
    setRoomAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import 'moment/locale/en-gb';
import {XMarkIcon} from "@heroicons/react/24/outline";
import FindVenues from "../../pages/venues/findVenues";

import { CheckIcon } from '@heroicons/react/20/solid'

const tiers = [


    {
        name: 'Fjölskyldan',
        id: 'tier-freelancer',
        href: '#',
        priceMonthly: '3500 kr.',
        description: 'Birtist á miðlum sem ná betur til foreldra, afa og ömmu.',
        features: ['5 products', 'Up to 1,000 subscribers', 'Basic analytics', '48-hour support response time'],
        mostPopular: false,
    },
    {
        name: 'Fullorðnir',
        id: 'tier-startup',
        href: '#',
        priceMonthly: '7500 kr.',
        description: 'Aukinn þungi settur á stóru miðlana, en hinir með í bland.',
        features: [
            '25 products',
            'Up to 10,000 subscribers',
            'Advanced analytics',
            '24-hour support response time',
            'Marketing automations',
        ],
        mostPopular: true,
    },
    {
        name: 'Bissness',
        id: 'tier-enterprise',
        href: '#',
        priceMonthly: '8500 kr.',
        description: 'Viðskiptasíður, vefir og fréttamiðlar.',
        features: [
            'Unlimited products',
            'Unlimited subscribers',
            'Advanced analytics',
            '1-hour, dedicated support response time',
            'Marketing automations',
        ],
        mostPopular: false,
    },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function EventStatistics(eventid) {
    let params = useParams();
    const data = useLoaderData() as any;
    console.log("params", params);
    let eventID = params.eventid;
    const [pageviews, setPageviews] = useState(0);
    const [edpviews, setEdpviews] = useState(0);
    const [ctass, setCtas] = useState(0);

    const getStatistics = weeks => {
        if(!weeks) weeks = 4;
        setPageviews(0);
        setEdpviews(0);
        setCtas(0);
        axios.get(`${process.env.REACT_APP_API_URL}/p/manage/event/statistics.do`, {
            params: {
                event: eventID,
                report: 'cta',
                weeks: weeks,
            }

        }).then(function (response) {
            // handle success
            setCtas(response.data.total);
            axios.get(`${process.env.REACT_APP_API_URL}/p/manage/event/statistics.do`, {
                params: {
                    event: eventID,
                    report: 'edp',
                    weeks: weeks,
                }

            }).then(function (response) {
                // handle success
                setEdpviews(response.data.total);
                axios.get(`${process.env.REACT_APP_API_URL}/p/manage/event/statistics.do`, {
                    params: {
                        event: eventID,
                        report: 'ads',
                        weeks: weeks,
                    }

                }).then(function (response) {
                    // handle success
                    setPageviews(response.data.total);
                });
            });


        });
    }

    useEffect(() => {

        getStatistics(eventID);
        //getPhotos();
        //handleArtists(data);

    }, []);




    return (<div className="bg-white py-4 sm:py-6">

            <div className="grid grid-cols-5">
                <div className="col-span-1">
                    <h5 className={"text-sm font-semibold text-gray-500"}>Birtingar</h5>
                    {pageviews > 0 && <div className="text-xl font-semibold text-gray-500"><NumericFormat
                            displayType={'text'}
                            thousandSeparator={","}
                            decimalScale={0}
                            value={pageviews}
                    /></div>}

                </div>
                <div className="col-span-1">
                    <h5 className={"text-sm font-semibold text-gray-500"}>Viðburðasíða</h5>
                    {edpviews > 0 && <div className="text-xl font-semibold text-gray-500"><NumericFormat
                            displayType={'text'}
                            thousandSeparator={","}
                            decimalScale={0}
                            value={edpviews}
                    /></div>}

                </div>
                <div className="col-span-1">
                    <h5 className={"text-sm font-semibold text-gray-500"}>Hlutfall</h5>
                    {pageviews > 0 && edpviews > 0 && <div className="text-xl font-semibold text-gray-500"><NumericFormat
                            suffix={'%'}
                            displayType={'text'}
                            decimalSeparator={","}
                            decimalScale={2}
                            value={(edpviews / pageviews) * 100}
                    /></div>}
                </div>
                <div className="col-span-1">
                    <h5 className={"text-sm font-semibold text-gray-500"}>Smellir</h5>
                    {ctass > 0 && <div className="text-xl font-semibold text-gray-500"><NumericFormat
                            displayType={'text'}
                            thousandSeparator={","}
                            decimalScale={0}
                            value={ctass}
                    /></div>}
                </div>
                <div className="col-span-1">
                    <h5 className={"text-sm font-semibold text-gray-500"}>CTA hlutfall</h5>
                    {ctass > 0 && edpviews > 0 && <div className="text-xl font-semibold text-gray-500"><NumericFormat
                            suffix={'%'}
                            displayType={'text'}
                            decimalSeparator={","}
                            decimalScale={2}
                            value={(ctass / edpviews) * 100}
                    /></div>}
                </div>

            </div>
            <div className={'mt-4'}>
                  <select className={'text-sm text-gray-500'} onChange={(e) => {getStatistics(e.target.value)}} defaultValue={'4'}>
                        <option value={'1'}>1 week</option>
                        <option value={'2'}>2 weeks</option>
                        <option value={'4'}>1 month</option>
                        <option value={'12'}>3 months</option>
                        <option value={'26'}>6 months</option>
                        <option value={'52'}>1 year</option>
                    </select>
            </div>
        </div>

    )
}
